import {
  fetchOnfidoAuthToken,
  initiateCreditCheckCallback,
  initiateOnfidoCallback,
} from '../api_client_portal/client_user'
import type { Resolvers } from '../generated/server/resolvers'

const Onfido: Resolvers = {
  Mutation: {
    onfidoToken: async () => await fetchOnfidoAuthToken(),
    onfidoCallback: async (_parent, { input }) => await initiateOnfidoCallback(input),
    creditCheckCallback: async () => await initiateCreditCheckCallback(),
  },
}

export default Onfido
